import { render, staticRenderFns } from "./dailyRegistration.vue?vue&type=template&id=3254ae85&scoped=true&"
import script from "./dailyRegistration.vue?vue&type=script&lang=js&"
export * from "./dailyRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254ae85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3254ae85')) {
      api.createRecord('3254ae85', component.options)
    } else {
      api.reload('3254ae85', component.options)
    }
    module.hot.accept("./dailyRegistration.vue?vue&type=template&id=3254ae85&scoped=true&", function () {
      api.rerender('3254ae85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/dailyRegistration.vue"
export default component.exports